import { UploadedFile } from '@backrs_ui/common-ui';

import { StoryDocument } from '@backrs_ui/grow-ui/src/redux/profile/profile';

import { Box, SxProps, Theme } from '@mui/material';

import { PublicProfileSection } from './PublicProfileSection';

type ProfileDocumentSectionProps = Readonly<{
  id: string;
  title: string;
  document?: StoryDocument;
}>;

/** Renders nothing when the document has no URL. */
export const ProfileDocumentSection = ({ id, title, document }: ProfileDocumentSectionProps) => {
  const url = document?.source_url || document?.media_url;

  if (!document || !url) return null;

  return (
    <PublicProfileSection
      title={title}
      variant={{
        type: 'CHILDREN',
        children: (
          <Box id={id} sx={documentSx} onClick={() => window.open(url, '_blank')}>
            <UploadedFile
              fileName={document.title ?? ''}
              fileSize={document.description ?? ''}
              fileType={document.source_url ? 'link' : (document.media_type ?? '')}
              borderColor="dark"
            />
          </Box>
        ),
      }}
    />
  );
};

const documentSx: SxProps<Theme> = { cursor: 'pointer' };
